<template>
    <div class="wrapper">
      <div class="body">
        <div class="text text-ellipsis-3-no-wrap">
          <template v-if="notification.contexts.item_week.faza === -1">
            <b>Germination.</b>            
          </template>
          <template v-else-if="notification.contexts.item_week.faza === 2">
            <b>Harvest.</b>            
          </template>
          <template v-else>
            <b>Week {{ notification.contexts.item_week.days }}.</b>
          </template>
          {{ notification.contexts.item_week.text }}
        </div>
      </div>
    </div>    
  </template>
  
  <script setup lang="ts">
   
  const props = defineProps<{ notification: Notification }>()
   
  </script>
  
<style scoped>
    
  .text{  
    white-space: pre-wrap;
  }
  
</style> 